'use strict';

var Reflux   = require('reflux'),
    Promise  = require('bluebird'),
    utils    = require('js/shared/utils/utils.js'),
    defaults = require('superagent-defaults'),
    request  = require('superagent-promise');

var request = defaults(request);

request.set('X-Requested-With', 'XMLHttpRequest')
       .type('application/json')
       .accept('application/json');

var TeamActions = Reflux.createActions({

    createTeam: { asyncResult: true, children: ['progressed'] },
    joinTeam: { asyncResult: true, children: ['progressed'] },
    leaveTeam: { asyncResult: true, children: ['progressed'] },

});

TeamActions.createTeam.listen(function (options) {
    this.promise(request
        .post('https://hackerapi.com/v1/events/hackthenorth/teams?token=' + options.token)
        .query({
        })
        .end()
    );
});


TeamActions.joinTeam.listen(function (options) {
    if(!options.teamId) {
        options.teamId = 'undefined';
    }
    this.promise(request
        .put('https://hackerapi.com/v1/teams/' + options.teamId + '?token=' + options.token)
        .query({
        })
        .end()
    );
});


TeamActions.leaveTeam.listen(function (options) {
    this.promise(request
        .del('https://hackerapi.com/v1/teams/' + options.teamId + '?token=' + options.token)
        .query({
        })
        .end()
    );
});




module.exports = TeamActions;



/*****************
 ** WEBPACK FOOTER
 ** ./js/shared/actions/team-actions.js
 ** module id = 258
 ** module chunks = 0 1 6
 **/